var _a;
import { deepmerge } from '@mui/utils';
import { theme as dark } from './dark';
import { theme as light } from './light';
import { theme as retro } from './retro';
export var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
    Theme["Retro"] = "retro";
})(Theme || (Theme = {}));
export var lightTheme = light;
export var darkTheme = deepmerge(light, dark);
export var retroTheme = deepmerge(light, retro);
export var themes = (_a = {},
    _a[Theme.Light] = lightTheme,
    _a[Theme.Dark] = darkTheme,
    _a[Theme.Retro] = retroTheme,
    _a);
